import * as React from 'react';
import NumericInput from './NumericInput';
import { HatType } from './Hat';
import { RulesMessages } from '../utils/validator';

interface AmountInputProps {
  placeHolder?: string;
  name: string;
  value?: string;
  id: string;
  label: string;
  rulesMessages?: RulesMessages;
  minValue?: number;
  maxValue?: number;
  required?: boolean;
  hasError?: boolean;
  errors?: any;
  theme?: 'night' | 'day';
  onChange?: (event: any, amount: number) => void;
  onComplete?: Function;
  onError?: Function;
  onBlur?: Function;
  hat?: HatType[];
  readOnly?: boolean;
  focus?: boolean;
  disabled?: boolean;
}

interface AmountInputState {
  inputValue: string;
}

export default function AmountInput(props: AmountInputProps) {
  const { hasError = false } = props;
  let propsValue;
  if (props.value) {
    if (props.value.startsWith('$')) {
      propsValue = props.value;
    } else {
      propsValue = `$${props.value}`;
    }
  }
  const [state, setState] = React.useState<AmountInputState>({
    inputValue: propsValue || ''
  });

  React.useEffect(() => {
    if (props.value) {
      if (props.value.startsWith('$')) {
        propsValue = props.value;
      } else {
        propsValue = `$${props.value}`;
      }
      if (propsValue !== state.inputValue) {
        setState({ ...state, inputValue: propsValue });
      }
    }
  }, [props.value]);

  return (
    <NumericInput
      placeHolder={props.placeHolder || '$0.00'}
      inputMode="decimal"
      value={state.inputValue}
      name={props.name}
      id={props.id}
      label={props.label}
      theme={props.theme}
      rulesMessages={props.rulesMessages}
      required={props.required}
      hasError={hasError}
      errors={props.errors}
      minValue={props.minValue}
      maxValue={props.maxValue}
      maxLength={10}
      allowDecimal
      hat={props.hat}
      onComplete={props.onComplete}
      onError={props.onError}
      onBlur={(e: any) => {
        if (e.target.value.startsWith('$')) {
          setState({
            ...state,
            inputValue: `$${Number(e.target.value.substr(1)).toFixed(2)}`
          });
        } else {
          setState({
            ...state,
            inputValue: `$${Number(e.target.value).toFixed(2)}`
          });
        }
        if (props.onBlur !== undefined) {
          props.onBlur(e);
        }
      }}
      onChange={(e: any) => {
        if (e.target.value) {
          if (e.target.value.startsWith('$')) {
            setState({ ...state, inputValue: e.target.value });
          } else {
            setState({ ...state, inputValue: `$${e.target.value}` });
          }
          if (props.onChange) {
            if (e.target.value.startsWith('$')) {
              props.onChange(e, Number(e.target.value.substr(1)));
            } else {
              props.onChange(e, Number(e.target.value));
            }
          }
        }
      }}
      readOnly={props.readOnly}
      focus={props.focus}
      disabled={props.disabled}
    />
  );
}
